export interface ExtractorSessionLifeCycleFilterType {
  selectedLifeCycles: server.dto.ExtractorSessionLifeCycles[]
}

export const ExtractorSessionLifeCycleOptions: server.dto.ExtractorSessionLifeCycle[] = serverReference.extractorSessionLifeCycles;

export const getExtractorSessionLifeCycleOption = (lifeCycle: server.dto.ExtractorSessionLifeCycles) => {
  return ExtractorSessionLifeCycleOptions.find(option => option.value === lifeCycle);
};

export const getExtractorSessionLifeCycleLabel = (lifeCycle: server.dto.ExtractorSessionLifeCycles) => {
  return getExtractorSessionLifeCycleOption(lifeCycle)?.text ?? lifeCycle;
};

export const getSortedLifeCycles = (filter: ExtractorSessionLifeCycleFilterType) => {
  return [...filter.selectedLifeCycles]
    .sort((a, b) => {
      const order = ExtractorSessionLifeCycleOptions.map(option => option.value);
      const indexA = order.findIndex(value => value === a);
      const indexB = order.findIndex(value => value === b);
      return indexA - indexB;
    });
};

export const initialExtractorSessionLifeCycleFilter: ExtractorSessionLifeCycleFilterType = {
  selectedLifeCycles: []
};
